import './App.css';
// import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { canAccessPath, defaultRedirectForRole } from './routeAccess';
import Home from './Home';
import JobScoringSummary from './JobScoringSummary';
import LeadScoredJobs from './LeadScoredJobs';
import CreateLeadNew from './CreateLeadNew';
import Leads from './Leads';
import LeadDetails from './LeadDetails';
import CareerAssociates from './CareerAssociates';
import ManagerMapping from './ManagerMapping';
import UploadManageJobs from './UploadManageJobs';
import ManageJobRoles from './ManageJobRoles';
import { AuthProvider, AuthContext } from './AuthProvider';
import Login from './Login';
import MFASetup from './MFASetup';
import MFAVerify from './MFAVerify';
import MFAManagement from './MFAManagement';
import Navbar from './Navbar';
import TopNavBar from './TopNavBar';
import CandidateMatchedJobs from './CandidateMatchedJobs';
import ScoringQueueDashboard from './ScoringQueueDashboard';
import React, { useContext } from 'react';
import CreateTasksForLead from './pages/CreateTasksForLead';
import CreateTasks from './pages/CreateTasks';
import ParsedEmails from './pages/ParsedEmails';
import LeadCareerAssociateMapping from './pages/LeadCareerAssociateMapping';
import ViewTasks from './pages/ViewTasks';
import TaskDetails from './pages/TaskDetails';
import LeadTasksView from './pages/LeadTasksView';
import TrendsDashboard from './pages/TrendsDashboard';

function PrivateRoute({ children }) {
  const { user, loading } = useContext(AuthContext);
  const location = useLocation();

  if (loading) return <div>Loading...</div>;
  // return user ? children : <Navigate to="/login" />;
  if (!user) return <Navigate to="/login" />;

  if (!user.mfa_setup_completed && location.pathname !== '/mfa-setup') {
    return <Navigate to="/mfa-setup" replace />;
  }

  if (user.mfa_setup_completed && !user.mfa_verified && location.pathname !== '/mfa-verify') {
    return <Navigate to="/mfa-verify" replace />;
  }

  // Adjust if your AuthProvider stores role differently
  const role =
    user?.role ||
    user?.role_name ||
    user?.user_metadata?.role ||
    '';

  // Enforce route-level permissions (blocks direct URL typing)
  if (!canAccessPath(role, location.pathname)) {
    return <Navigate to={defaultRedirectForRole(role)} replace />;
  }
  return children;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppLayout />
      </Router>
    </AuthProvider>
  );
}

function AppLayout() {
  const { pathname } = require('react-router-dom').useLocation();
  const isLoginPage = pathname === '/login';
  return (
    <div className="min-h-screen flex flex-row">
      {!isLoginPage && <Navbar />}
      <div className="flex-1 flex flex-col">
        {!isLoginPage && <TopNavBar />}
        <main className="flex-1 flex flex-col">
          <Routes>
            <Route path="/" element={<PrivateRoute><Home /></PrivateRoute>} />
            <Route path="/job-scoring-summary" element={<PrivateRoute><JobScoringSummary /></PrivateRoute>} />
            <Route path="/lead-scored-jobs" element={<PrivateRoute><LeadScoredJobs /></PrivateRoute>} />
            <Route path="/create-lead" element={<PrivateRoute><CreateLeadNew /></PrivateRoute>} />
            <Route path="/leads" element={<PrivateRoute><Leads /></PrivateRoute>} />
            <Route path="/leads/:id" element={<PrivateRoute><LeadDetails /></PrivateRoute>} />
            <Route path="/career-associates" element={<PrivateRoute><CareerAssociates /></PrivateRoute>} />
            <Route path="/manager-mapping" element={<PrivateRoute><ManagerMapping /></PrivateRoute>} />
            <Route path="/scoring-queue-dashboard" element={<PrivateRoute><ScoringQueueDashboard /></PrivateRoute>} />
            <Route path="/manage-jobs" element={<PrivateRoute><UploadManageJobs /></PrivateRoute>} />
            <Route path="/manage-job-roles" element={<PrivateRoute><ManageJobRoles /></PrivateRoute>} />
            <Route path="/candidate-matched-jobs" element={<PrivateRoute><CandidateMatchedJobs /></PrivateRoute>} />
            <Route path="/login" element={<Login />} />
            <Route path="/mfa-setup" element={<PrivateRoute><MFASetup /></PrivateRoute>} />
            <Route path="/mfa-verify" element={<PrivateRoute><MFAVerify /></PrivateRoute>} />
            <Route path="/mfa-management" element={<PrivateRoute><MFAManagement /></PrivateRoute>} />
            <Route path="/view-tasks" element={<PrivateRoute><ViewTasks /></PrivateRoute>} />
            <Route path="/lead-tasks/:leadId" element={<PrivateRoute><LeadTasksView /></PrivateRoute>} />
            <Route path="/task-details/:taskId" element={<PrivateRoute><TaskDetails /></PrivateRoute>} />
            <Route path="/create-tasks-for-lead" element={<PrivateRoute><CreateTasksForLead /></PrivateRoute>} />
            <Route path="/create-tasks" element={<PrivateRoute><CreateTasks /></PrivateRoute>} />
            <Route path="/parsed-emails" element={<PrivateRoute><ParsedEmails /></PrivateRoute>} />
            <Route path="/lead-career-associate-mapping" element={<PrivateRoute><LeadCareerAssociateMapping /></PrivateRoute>} />
            <Route path="/trends-dashboard" element={<PrivateRoute><TrendsDashboard /></PrivateRoute>} />
          </Routes>
        </main>
      </div>
    </div>
  );
}

export default App;
